// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../Content/img/analytics-img.png", import.meta.url);
// Module
var code = `<div class="corner-popup">
    <img src="${___HTML_LOADER_IMPORT_0___}">
    <div class="text-center padding">
        <h3 class="text-success"><strong>Help us improve</strong></h3>
        <p class="small">Would you allow us to gather anonymous information about Studio usage to improve future versions of our product?</p>
        <a data-bind="click: collectUsageData" class="btn btn-success">Yes, I want to help</a><br>
        <a data-bind="click: doNotCollectUsageData" class="btn btn-xs text-muted">No, thank you</a>
    </div>
</div>
`;
// Exports
export default code;